import { z } from "zod";
/**
 * An error in a player's browser, reported to `POST /api/client-errors` (review 0019 S8, U6, U7).
 * Short by design: a message and a clipped stack, the handshake stage when that is where it broke,
 * and the event id the player sees on screen. No URLs, no frame ids, no referrer.
 */
export const clientErrorSchema = z.object({
    kind: z.enum(["error", "rejection", "boundary", "handshake"]),
    eventId: z.string().uuid(),
    message: z.string().max(500),
    stack: z.string().max(2000).optional(),
    stage: z.string().max(40).optional(),
    platform: z.string().max(40).optional(),
});
/** The largest report body the server reads; anything longer is refused unread. */
export const CLIENT_ERROR_MAX_BYTES = 4096;
//# sourceMappingURL=ops.js.map